import React from 'react';
import PropTypes from 'prop-types';
import ProductBetterTogetherView from './ProductBetterTogetherView';

export const ProductBetterTogether = (props) => {
  const {
    product,
    addToCart,
    better_together,
    permissions,
    isIPSUser,
    isLoggedIn,
    showVAT,
    webGroupPermissions,
    setMiniPDP,
    webGroupId,
    showPrice,
    loginLink,
    accountLink,
  } = props;
  if (isIPSUser) return null;
  const displayBetterTogether =
    better_together?.prodList?.length &&
    permissions?.enable_accessory_purchase &&
    permissions?.enable_warranty_purchase;
  const productTogetherView = (
    <ProductBetterTogetherView
      product={product}
      addToCart={addToCart}
      better_together={better_together?.prodList}
      isLoggedIn={isLoggedIn}
      showVAT={showVAT}
      permissions={permissions}
      webGroupPermissions={webGroupPermissions}
      setMiniPDP={setMiniPDP}
      webGroupId={webGroupId}
      showPrice={showPrice}
      loginLink={loginLink}
      accountLink={accountLink}
    />
  );
  return displayBetterTogether ? productTogetherView : null;
};

export default ProductBetterTogether;

ProductBetterTogether.propTypes = {
  product: PropTypes.object,
  addToCart: PropTypes.func,
  better_together: PropTypes.object,
  permissions: PropTypes.object,
  isIPSUser: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  showVAT: PropTypes.bool,
  webGroupPermissions: PropTypes.object,
  setMiniPDP: PropTypes.func,
  webGroupId: PropTypes.string,
  showPrice: PropTypes.bool,
  loginLink: PropTypes.string,
  accountLink: PropTypes.string,
};

ProductBetterTogether.defaultProps = {
  product: {},
  addToCart: () => {},
  better_together: {},
  permissions: {
    enable_warranty_purchase: true,
    enable_accessory_purchase: true,
    enable_purchasing_popup: true,
    enable_personal_product_list: false,
    enable_inventory_search: false,
    enableViewPricing: true,
  },
  isIPSUser: false,
  isLoggedIn: false,
  showVAT: false,
  webGroupPermissions: {
    enableListPrice: true,
    disableStockAndPrice: false,
  },
  setMiniPDP: () => {},
  webGroupId: '',
  showPrice: true,
};
